import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  startScan: {
    description: 'Button text to enter scan verification mode',
    defaultMessage: 'Scan to Verify',
    id: 'RGYEoh',
  },
  exitScan: {
    description: 'Button text to exit scan verification mode',
    defaultMessage: 'Exit Scanning',
    id: '9utmVj',
  },
  shipmentItemsVerified: {
    description: 'Success Toast',
    defaultMessage: 'Shipment items verified.',
    id: 'VzXQS7',
  },
  shipmentWarningToast: {
    description: 'Warning Toast',
    defaultMessage: 'There was a problem verifying this shipment. Please try again.',
    id: 'rR2xss',
  },
  markOrderAsVerified: {
    description: 'Button text to mark order as verified',
    defaultMessage: 'Mark Order as Verified',
    id: 'QfjaBr',
  },
  verifyAll: {
    description: 'scan.productCodeInput.verifyAll',
    defaultMessage: 'Verify all',
    id: '3STbqs',
  },
  clearAll: {
    description: 'scan.productCodeInput.clearAll',
    defaultMessage: 'Clear all',
    id: 'qtxUAG',
  },
});
